import {
  ListAgreementPayloadDto
} from '@features/agreement/application/use_cases/list-agreement/dto/list-agreement.payload.dto';
import {
  ListAgreementResponseDto
} from '@features/agreement/application/use_cases/list-agreement/dto/list-agreement.response.dto';
import {
  ListAgreementHttpPayloadDto
} from '@features/agreement/infrastructure/http/list-agreement/list-agreement.http.payload.dto';
import {
  ListAgreementHttpResponseDto
} from '@features/agreement/infrastructure/http/list-agreement/list-agreement.http.response.dto';

export class ListAgreementHttpMapper {

  static toResponse(data: ListAgreementHttpResponseDto): ListAgreementResponseDto {
    return {
      data: data.data.map(item => ({
        id: item.id.toString(),
        company_id: item.company_id.toString(),
        name: item.name,
        slug: item.slug,
        id_template: item.id_template,
        type: item.type,
        config: JSON.parse(item.config),
        use_personalized_scoring: item.use_personalized_scoring == 1,
        status: item.status == 1
      }))
    };
  }

  static toInfra(data: ListAgreementPayloadDto): ListAgreementHttpPayloadDto {
    return {};
  }

}
